import { useRef, useEffect, useCallback, useState } from "react";
import useResizeObserver from "use-resize-observer/polyfilled";
import { select } from "d3";
import throttle from "./throttle";

export default function useD3(render, deps) {
    const elemRef = useRef();
    const [dimensions, setDimensions] = useState();

    const onResize = useCallback(throttle(setDimensions, 50), []);

    const { ref: dimensionRef } = useResizeObserver({
        onResize
    });

    useEffect(
        () => {
            if (!dimensions) return;
            render(select(elemRef.current), dimensions);
        },
        [...deps, dimensions]
    );

    return [elemRef, dimensionRef];
}
